// extracted by mini-css-extract-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary_CheckoutSummary__a53c9","CheckoutSummaryDiv":"CheckoutSummary_CheckoutSummaryDiv__SGcem"};